module.exports = __webpack_public_path__ + "img/view-live.46bdcda3.webp";